import { useTranslations } from 'next-intl'

import { Props } from './index.pc'
import { Heading } from '../../common'

export const MobileTransportation = ({ transportation }: Props) => {
  const t = useTranslations('room_detail')

  return (
    <section className="space-y-4 px-4 pb-10">
      <Heading size="small">{t('transportation.title')}</Heading>
      <p className="typo-body2 font-normal whitespace-break-spaces text-gray-900">
        {transportation}
      </p>
    </section>
  )
}
